﻿{
  "createAccount": "Crear cuenta",
  "subscription": "Suscripción",
  "oneTimePurchase": "Compra única",
  "billingDetails": "Detalles de facturación",
  "paymentDetails": "Detalles de pago",
  "requestAQuote": "Formulario de solicitud para la organización",
  "reviewOrder": "Revisar el pedido",
  "thankYouForYourOrder": "¡Gracias por su pedido!",
  "joinTheCommunity": "Unirse a la Comunidad",
  "startTrial": "Comience la prueba",
  "yourTrialHasEnded": "Su período de prueba ha terminado.",
  "taxExempt": "Exento de impuestos",
  "taxExemptThankYou": "¡Carga exitosa!",
  "planDetails": "Detalles de mi suscripción",
  "modifyPlan": "Modificar el plan",
  "modifyPaymentDetails": "Modificar los detalles de pago",
  "redirect": "Redirigiéndolo a Boardmaker",
  "perpetualTrial": "Descargue su prueba gratuita de {{trialLength}} días.",
  "perpetualThankYou": "¡Su software está listo!",
  "downloads": "Descargar Boardmaker",
  "partner": "Buscar un socio",
  "intro": "A continuación, seleccione un producto Boardmaker para descargar la última versión para su dispositivo.",
"systemRequirements": "Requisitos del sistema",
"releaseNotes": "Notas de la versión",
"comparison": "Comparar suscripción y licencia"
}
